import i18n from "../../i18n";
import React, { useMemo } from "react";
import { Modal, Table, Text, ScrollArea } from "@mantine/core";
import { getEntityLabel } from "../../data/mcaEntities";
import { getMcaWatchFieldExplanations } from "./mcaWatchFieldLabels";

const McaWatchFieldExplanationModal = ({
  opened,
  onClose,
  entityKey,
  fieldPaths = [],
}) => {
  const rows = useMemo(
    () => getMcaWatchFieldExplanations(entityKey, fieldPaths),
    [entityKey, fieldPaths]
  );

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Condition Field Guide — ${getEntityLabel(entityKey) || "Entity"}`}
      size={1040}
      styles={{
        modal: { width: "min(1040px, calc(100vw - 48px))" },
      }}
    >
      <Text size="sm" color="dimmed" mb="md">
        Field paths with English and Chinese labels to help configure trigger conditions.
      </Text>
      <ScrollArea h={480}>
        <Table
          striped
          highlightOnHover
          withBorder
          verticalSpacing="sm"
          sx={{ tableLayout: "auto", minWidth: 720 }}
        >
          <thead>
            <tr>
              <th style={{ width: "34%" }}>{i18n.t("Field")}</th>
              <th style={{ width: "33%" }}>{i18n.t("English")}</th>
              <th style={{ width: "33%" }}>中文</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.field}>
                <td>
                  <Text size="sm" weight={500} sx={{ whiteSpace: "nowrap" }}>
                    {row.field}
                  </Text>
                </td>
                <td>
                  <Text size="sm">{row.english}</Text>
                </td>
                <td>
                  <Text size="sm">{row.chinese}</Text>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ScrollArea>
    </Modal>
  );
};

export default McaWatchFieldExplanationModal;
